import React from 'react';
import { MdAdd } from '../../Common/Icons';
import './QuickAdd.css';
import {
  // Link,
  Redirect,
} from 'react-router-dom';
import { setObjInLS } from '../../Helpers/LocalStorage';
import { t } from 'i18next';

const RenderGroup = ({ title = '', routes = [], handleAction }) => (
  <div className="quick-add-inner">
    <div className="main-heading">{title}</div>
    <ul>
      {routes.map((val, index) => (
        <li
          key={index}
          onClick={() => handleAction(val.route, Boolean(val?.flag))}
        >
          <MdAdd /> {val.name}
        </li>
      ))}
    </ul>
  </div>
);

function QuickAdd({ hideQuickAdd }) {
  const [redirect, setRedirect] = React.useState(false);

  if (redirect) return <Redirect to="/r" />;

  const doRedirect = (url, vendorFlag = false) => {
    setObjInLS('module', { urlPath: url, vendorFlag: vendorFlag });
    setRedirect(true);
    hideQuickAdd();
  };

  return (
    <div className="quick-add">
      <RenderGroup
        title={t('Settings.general')}
        routes={[
          { route: '/contacts/add', name: t('Contacts.contact') },
          { route: '/items/add', name: t('Items.items') },
          { route: '/item-adjustments/add', name: t('Items.item_adjustments') },
        ]}
        handleAction={doRedirect}
      />
      <RenderGroup
        title={t('Settings.sales')}
        routes={[
          {
            route: '/contacts/add',
            name: t('Contacts.contact_type_options.customer'),
          },
          {
            route: '/invoices/add',
            name: t('Invoice.title_secondary'),
          },
          { route: '/salesorders/add', name: t('saleOrder.sales_order') },
        ]}
        handleAction={doRedirect}
      />
      <RenderGroup
        title={t('Items.purchase')}
        routes={[
          {
            route: '/contacts/add',
            name: t('Contacts.contact_type_options.vendor'),
            flag: true,
          },
          { route: '/bills/add', name: t('common.bills') },
          {
            route: '/purchaseorders/add',
            name: t('PurchaseOrder.purchaseOrder'),
          },
        ]}
        handleAction={doRedirect}
      />
    </div>
  );
}

export default QuickAdd;
